import React from 'react';

import Download from 'scenes/CustomAudiences/Audiences/components/DownloadForm';

import {
  useArchiveAudience,
  useDeleteAudience,
  useExportAudience,
  useRestoreAudience,
  useSyncAudience,
  useSyncPartnerAudiencesAudience,
} from '../../data/mutations';
import Actions from './Actions';
import { TYPE_AUDIENCE } from 'scenes/CustomAudiences/Audiences/constants';

export default ({
  actions,
  onEdit,
  onDuplicate,
  data,
  onClose,
  onAddPartnerAudiences,
  limit = 2,
  onOpenChildComponent,
  withPartnerActions = true,
}) => {
  const [syncAudience] = useSyncAudience();
  const [exportAudience] = useExportAudience();
  const [archiveAudience] = useArchiveAudience();
  const [restoreAudience] = useRestoreAudience();
  const [deleteAudience] = useDeleteAudience();
  const [syncPartnerAudiencesAudience] = useSyncPartnerAudiencesAudience();

  const withDuplicate = data?.type?.id === TYPE_AUDIENCE;

  const handleSync = async () => {
    await syncAudience({
      id: data?.id,
      name: data?.name,
    });
  };
  const handleExport = async () => {
    onOpenChildComponent(Download, {
      name: data.name,
      onSubmit: async (values) => {
        await exportAudience({
          id: data.id,
          name: data.name,
          config: values,
        });
      },
    });
  };
  const handleArchive = async () => {
    await archiveAudience({ id: data.id, name: data.name });
  };
  const handleRestore = async () => {
    await restoreAudience({ id: data.id, name: data.name });
  };
  const handleDelete = async () => {
    await deleteAudience({ id: data.id, name: data.name });
    onClose?.();
  };
  const handleSyncPartnerAudiences = async () => {
    await syncPartnerAudiencesAudience({
      audience: data?.id,
      name: data?.name,
      partnerAudiences: data?.partnerAudiences,
    });
  };
  const handleAddPartnerAudiences = () => {
    onAddPartnerAudiences?.(data);
  };
  const handleEdit = async () => {
    await onEdit({ id: data.id, type: data.type });
  };
  const handleDuplicate = async () => {
    await onDuplicate({ id: data.id });
  };

  return (
    <Actions
      limit={limit}
      actions={actions}
      onSync={handleSync}
      onExport={handleExport}
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      onSyncPartnerAudiences={handleSyncPartnerAudiences}
      onAddPartnerAudiences={handleAddPartnerAudiences}
      onArchive={handleArchive}
      onRestore={handleRestore}
      onDelete={handleDelete}
      withPartnerActions={withPartnerActions}
      withDuplicate={withDuplicate}
    />
  );
};
